import styled from 'styled-components';

const isDarkTheme = (theme: { colors: { text: string; white: string } }): boolean => (
  theme.colors.text === theme.colors.white
);

const Wrapper = styled.div<{ $width?: string; $backgroundColor?: string; $textColor?: string; }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 8px;
  gap: 4px;
  height: 26px;
  background: ${(props) => props.$backgroundColor || props.theme.colors.surface_muted};
  border-radius: 6px;
  min-width: fit-content;
  cursor: ${(props) => (props.onClick ? 'pointer' : 'default')};

  p {
    font-size: 13px;
    line-height: 17px;
    color: ${(props) => props.$textColor || props.theme.colors.text};
  }

  p.fixed {
    text-align: center;
    width: ${(props) => `${props.$width ? props.$width : 80}px`};
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  /* Icons with hardcoded dark-theme greys stay readable on light surfaces. */
  .icon {
    color: ${(props) => (
    isDarkTheme(props.theme) ? props.theme.colors.inactive : props.theme.colors.text
  )};
  }
`;

export default { Wrapper };
